import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { ProviderContextService } from '@app/core/services/provider-context.service';

/**
 * Pantallas de SPEI (`/entities`, `/transactions`, `/fondeo`): si la sesión no
 * eligió todavía con qué cuenta padre SPEI opera y hay más de una que elegir, se
 * pasa primero por el selector existente (`/account-selection?returnUrl=…`) y al
 * elegir se aterriza en la pantalla pedida. Cubre el menú Suite y la URL directa.
 *
 * Va DESPUÉS de `gestorGuard`: a quien no tiene SPEI lo rebota aquel, no este.
 * La regla vive en `ProviderContextService.speiEntryRedirect`.
 */
export const speiProviderGuard: CanActivateFn = (_route, state) =>
  inject(ProviderContextService).speiEntryRedirect(state.url) ?? true;
